import template from 'account-navigation-wrapper.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { accountMobileNavUtil } from '@core/js/utils/accountMobileNavUtils';
import * as Helpers from '../../../account/js/helpers/helpers';

import addDropdownSupport from '../../../core/js/uiSupport/dropDown';
import accordionSupport from '../../../core/js/uiSupport/accordion';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-account-navigation',
        watch: ['core.initialized', 'core.loggedIn', 'core.profile', 'core.deviceCharacteristics'],
        name: 'accountNavComponent',
        template: template,
        afterConstruction: afterConstruction,
        afterRender: afterRender,
        generateDictionary: generateDictionary,
        feature: 'account'
    };
    return generate(config, store, overrides, getDefaultOptions(store));
}

function afterConstruction(store) {
    // ensure account app and nav are fully loaded before adding dropdown support
    $(document).on('REMOVE_LOADER', (e) => {
        addDropdownSupport(this, this.templateLocation);
    });
}

function afterRender(store) {
    // We need to add to ensure accordion support on re-renders
    accordionSupport(this, '.js-account-nav');
    accountMobileNavUtil(store.getState());
    addDropdownSupport(this, this.templateLocation);
}

function generateDictionary(state, dict, config) {
    const data = getNavH2Data(state, config.feature);
    data.helpers = Helpers;
    const result = Object.assign({}, dict, data);

    return result;
}

function getNavH2Data(state, feature) {
    let data;

    if (feature === 'wishlist') {
        const secondaryH2Text = _.get(state, 'wishlist.name');
        data = {
            h2Slug: 'account_navigation-wishLists',
            secondaryH2Text: secondaryH2Text ? ': ' + secondaryH2Text : '',
            useGrid: true
        };
    } else if (feature === 'orders') {
        data = {
            h2Slug: 'account_navigation-orderHistory'
        };
    } else if (feature === 'favorites') {
        data = {
            h2Slug: 'account_navigation-favorites'
        };
    } else {
        data = {
            h2Slug: 'account_navigation-my-account'
        };
    }

    return data;
}
